'use client'

import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { useProductSelection } from '@/contexts/ProductSelectionContext'
import ContactFormModal from '@/components/ContactFormModal'
import Button from '@/components/ui/Button'
import { FaEnvelope, FaShoppingCart } from 'react-icons/fa'

const navItems = [
  { href: '/', label: 'Anasayfa' },
  { href: '/hakkimda', label: 'Hakkımızda' },
  { href: '/hizmetler', label: 'Hizmetler' },
  { href: '/urunler', label: 'Ürünler' },
  { href: '/referans', label: 'Referans' },
  { href: '/haberler', label: 'Haberler' },
  { href: '/iletisim', label: 'İletişim' },
]

export default function Navigation() {
  const pathname = usePathname()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const { count } = useProductSelection()

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center">
            <Image
              src="/images/logo.jpg"
              alt="HAYSETEC Logo"
              width={150}
              height={60}
              className="h-12 w-auto object-contain"
              priority
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => {
              const isActive = pathname === item.href
              return (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-gray-100 text-gray-900 border-b-2 border-primary-500'
                      : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  {item.label}
                </Link>
              )
            })}
            
            {/* İletişim Butonu - Sadece ürün eklenince görünür */}
            {count > 0 && (
              <Button
                onClick={() => setIsContactModalOpen(true)}
                className="ml-4 flex items-center gap-2"
              >
                <FaEnvelope />
                <span className="bg-white text-primary-600 rounded-full px-2 py-0.5 text-xs font-bold">
                  {count}
                </span>
                <span className="hidden lg:inline">Bilgi Al</span>
              </Button>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100"
            aria-label="Menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            {navItems.map((item) => {
              const isActive = pathname === item.href
              return (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-gray-100 text-gray-900 border-l-4 border-primary-500'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {item.label}
                </Link>
              )
            })}
            
            {/* Mobil İletişim Butonu - Sadece ürün eklenince görünür */}
            {count > 0 && (
              <button
                onClick={() => {
                  setIsContactModalOpen(true)
                  setIsMobileMenuOpen(false)
                }}
                className="w-full mt-4 mx-4 px-4 py-3 bg-primary-600 text-white rounded-lg font-medium flex items-center justify-center gap-2 hover:bg-primary-700 transition-colors"
              >
                <FaEnvelope />
                Bilgi Al
                <span className="bg-white text-primary-600 rounded-full px-2 py-0.5 text-xs font-bold">
                  {count}
                </span>
              </button>
            )}
          </div>
        )}
      </div>
      
      {/* Contact Modal */}
      <ContactFormModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </nav>
  )
}

